module.exports = __webpack_public_path__ + "img/glass.4999a3fb.png";